import React from 'react';
import {
  TileWrapper, NameWrapper, ValueWrapper, MetricDivider,
} from './styled';

const Tile = ({ name, value, showDivider = true }) => (
  <>
    <TileWrapper>
      <NameWrapper>
        {name}
      </NameWrapper>
      <ValueWrapper>
        {value}
      </ValueWrapper>
    </TileWrapper>
    {showDivider ? <MetricDivider /> : null}
  </>
);

export default Tile;
